import React from 'react';
import './Menu.sass';

import cx from 'classnames';

import Collapsible from '../collapsible/Collapsible';
import ChannelLink from '../../containers/channelUtils/ChannelLink';

function MenuItem({name, slug, active}) {
  return (
    <div className={cx('menu__item', active && 'menu__item--active')}>
      <ChannelLink to={`/${slug}`}>
        <span className="menu__title">{name}</span>
      </ChannelLink>
    </div>
  );
}

export default class Menu extends React.PureComponent {
  static defaultProps = {
    breadcrumbs: []
  };

  constructor(props) {
    super(props);

    this.state = {openedItem: null};

    const {breadcrumbs, items} = this.props;
    if (breadcrumbs && items) {
      const opened = items.find(item => !!breadcrumbs.find(breadcrumb => item.id === breadcrumb.id));
      this.state = {openedItem: opened && opened.id};
    }
  }

  componentDidUpdate(prevProps) {
    const {breadcrumbs, items} = this.props;

    if (breadcrumbs && items && prevProps.breadcrumbs !== breadcrumbs) {
      const opened = items.find(item => !!breadcrumbs.find(breadcrumb => item.id === breadcrumb.id));
      if (opened) {
        this.setState({openedItem: opened && opened.id});
      }
    }
  }

  handleCollapsibleClick = idx => this.setState(prevState => ({
    openedItem: prevState.openedItem === idx ? null : idx
  }));

  isActive = (taxon) => !!this.props.breadcrumbs.find(it => it.code === taxon.code);

  render() {
    const {items, mobile} = this.props;
    const {openedItem} = this.state;

    return (
      <aside className={cx("menu", mobile && "menu--mobile")}>
        <div className="menu__content">
          {items.map(item => item.children && item.children.length ? (
            <Collapsible
              key={item.id}
              trigger={
                <ChannelLink to={`/${item.slug}`} onClick={e => e.stopPropagation()}>
                  <span className="menu__title">{item.name}</span>
                </ChannelLink>
              }
              open={item.id === openedItem}
              duration={400}
              onTriggerClick={() => this.handleCollapsibleClick(item.id)}
              className="menu__item  menu__item--has-children"
              openedClassName="menu__item  menu__item--has-children  menu__item--opened"
              triggerClassName={cx('menu__trigger', this.isActive(item) && 'menu__trigger--active')}
              contentOuterClassName="menu__list"
            >
              {item.children.map(child => <MenuItem key={child.id} active={this.isActive(child)} {...child}/>)}
            </Collapsible>
          ) : (
            <MenuItem key={item.id} active={this.isActive(item)} {...item}/>
          ))}
        </div>
      </aside>
    );
  }
}



// WEBPACK FOOTER //
// ./components/menu/Menu.js